import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import './LanguageSelector.css';

const languages = [
  { code: 'en', label: 'EN' },
  { code: 'uk', label: 'UK' },
  { code: 'ru', label: 'RU' },
];

function LanguageSelector({ compact = false }) {
  const { i18n, t } = useTranslation('common');

  const handleLanguageChange = (langCode) => {
    if (langCode === i18n.language) return;
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode);
  };

  if (compact) {
    const currentIndex = languages.findIndex(l => l.code === i18n.language);
    const nextIndex = (currentIndex + 1) % languages.length;
    return (
      <button
        className="language-selector-compact"
        onClick={() => handleLanguageChange(languages[nextIndex].code)}
        title={t('language.select')}
      >
        <Globe size={18} />
        <span>{languages[Math.max(0, currentIndex)].label}</span>
      </button>
    );
  }

  return (
    <div className="lang-pills" role="group" aria-label={t('language.select')}>
      {languages.map((lang) => (
        <button
          key={lang.code}
          type="button"
          className={lang.code === i18n.language ? 'active' : ''}
          onClick={() => handleLanguageChange(lang.code)}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSelector;
